module.exports = __webpack_public_path__ + "img/Redshift-Distribution-Styles.feaefbd3.png";